import React from 'react'
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

const Cardsolar = () => {
    const { t } = useTranslation();
    return (
        <>
            <NavLink to={t('url.com-solar')} className='card-link'>
                <div className="card">
                    <img src={`${process.env.PUBLIC_URL}/images/cards/product-solar.png`} alt="" />
                    <div className="card-text">
                        <h3>{t('pages.comsolar')}</h3>
                    </div>
                    <div className="readmore">
                        <NavLink to={t('url.com-solar')} exact>{t('storage.product-text-4')}</NavLink>
                    </div>
                </div>
            </NavLink>
            <div className="card-shadow">
                <img src={`${process.env.PUBLIC_URL}/images/cards/shadow.png`} alt="shadow card" />
            </div>
        </>
    )
}

export default Cardsolar